module.exports = __webpack_public_path__ + "assets/19c3682eb3d19bce0aef84bf048b57c6.mp3";